import PropTypes from 'prop-types';
import React from 'react';
import GridView from "./GridView";
import ComplexParam from "../ComplexParam";
import {GridRowEditMode} from "./GridView";

class GridViewInlineEdit2 extends React.Component {
    get rowInEditIndex() {
        return this.props.dataItem.rowInEditIndex;
    };

    isEditableCell = (fieldInfo, rowIndex) => {
        const readOnly = this.props.readOnly || this.props.dataItem.getFieldIsReadOnly(fieldInfo, rowIndex);
        return !readOnly;
    };

    renderParams = (h, rowParams) => {
        if (this.props.renderRowParams) {
            return this.props.renderRowParams(h, rowParams);
        }
        else {
            let renderCellExDefault = rowParams.renderCellEx;
            rowParams.renderCellEx = (cellParams) => {
                if (!this.isEditableCell(cellParams.fieldInfo, cellParams.rowIndex)) {
                    if (renderCellExDefault) {
                        return renderCellExDefault(cellParams);
                    }
                    return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
                }

                return h.ed(cellParams.fieldInfo.Name, {canCreateDoc4Rels: this.props.canCreateDoc4Rels});
            };
            rowParams.rowClassName = "gridView-inlineEdit-editingRow";

            return rowParams.renderRowFromParams(rowParams);
        }
    };

    renderRowEx = (rowParams) => {
        const customFieldExMap = {...this.props.customFieldExMap, ...rowParams.customFieldExMap};
        if (!this.props.readOnly) {
            if (rowParams.key === this.rowInEditIndex) {
                return (
                    <React.Fragment key={rowParams.key}>
                        <ComplexParam dataItem={rowParams.dataItem} rowIndex={rowParams.rowIndex}
                                      renderParams={(h) => this.renderParams(h, rowParams)}
                                      rootPath={this.props.dataItemPath} autoApplyParams={false}
                                      showSearchBar={false} showApplyButton={false}
                                      readOnly={this.props.readOnly} applyOnEnterKey={false}
                                      renderWithoutContainer={true}
                                      overrideVisibility={this.props.overrideVisibilityEdit}
                                      customFieldExMap={customFieldExMap}
                        />
                    </React.Fragment>
                );
            }

            rowParams.rowClassName = "gridView-inlineEdit-commonRow";

            //переопределяем удаление, чтобы попытаться сохранить редактируемую строку
            let onDeleteRowDefault = rowParams.onDeleteRow;
            rowParams.onDeleteRow = (rowIndex) => {
                if (this.rowInEditIndex !== -1) {
                    rowParams.onSaveRow(() => {
                        onDeleteRowDefault(rowIndex);
                    });
                }
                else {
                    onDeleteRowDefault(rowIndex);
                }
            };

            //переопределяем редактирование, чтобы попытаться сохранить редактируемую строку
            let onEditRowDefault = rowParams.onEditRow;
            rowParams.onEditRow = (rowIndex) => {
                if (this.rowInEditIndex !== -1) {
                    rowParams.onSaveRow(() => {
                        onEditRowDefault(rowIndex);
                    });
                }
                else {
                    onEditRowDefault(rowIndex);
                }
            };

            if (!rowParams.mobileMode) {
                let rowCellClick = () => rowParams.onEditRow(rowParams.rowIndex);

                //переопределяем клик на ячейку, чтобы попытаться сохранить редактируемую строку
                if (rowParams.onCellClick) {
                    let onCellClickDefault = rowParams.onCellClick;
                    rowParams.onCellClick = (row, fieldInfo, e) => {
                        onCellClickDefault(row, fieldInfo, e, rowCellClick);
                    };
                } else {
                    rowParams.onCellClick = rowCellClick;
                }
            }
        }

        return rowParams.renderRowFromParams(rowParams);
    };

    render() {
        return (
            <GridView {...this.props}
                      rowEditMode={GridRowEditMode.inline}
                      renderRowEx={this.renderRowEx}
            />
        );
    }
}

GridViewInlineEdit2.defaultProps = {
    dataItemPath: "/"
};

GridViewInlineEdit2.propTypes = {
    dataItem: PropTypes.object.isRequired,
    renderRowParams: PropTypes.func,
    dataItemPath: PropTypes.string
};

export default GridViewInlineEdit2;